import styled from 'styled-components';

interface ColumnProps {
  alignItems?: string;
  border?: string;
  flex?: number;
  justifyContent?: string;
  margin?: string;
  padding?: string;
  width?: string;
}

const Column = styled.div<ColumnProps>`
  ${({ border }) => (border ? `border: ${border};` : null)}
  display: flex;
  flex: ${({ flex }) => flex || 1};
  flex-direction: column;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  ${({ margin }) => `margin: ${margin};` || null}
  ${({ padding }) => `padding: ${padding};` || null}
  width: ${({ width }) => width || '100%'};
`;

export { Column };
